import { render, staticRenderFns } from "./ChartReadme.vue?vue&type=template&id=487fb119&scoped=true&"
import script from "./ChartReadme.vue?vue&type=script&lang=js&"
export * from "./ChartReadme.vue?vue&type=script&lang=js&"
import style0 from "./ChartReadme.vue?vue&type=style&index=0&id=487fb119&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487fb119",
  null
  
)

export default component.exports